import { useRef } from "react";
import { Navigate } from "react-router-dom";
import MainPage from "@/pages/MainPage";
import { readLastVisitedProjectId, resolveProjectEntryPath } from "@/services/projectLastVisitedPanel";

let hasCheckedThisSession = false;

const HomeRedirect = () => {
  const targetRef = useRef<string | null>(null);

  if (!hasCheckedThisSession) {
    hasCheckedThisSession = true;
    const projectId = readLastVisitedProjectId();
    targetRef.current = projectId === null ? null : resolveProjectEntryPath(projectId);
  }

  if (targetRef.current !== null) {
    return <Navigate to={targetRef.current} replace />;
  }

  return <MainPage />;
};

export default HomeRedirect;
